import { usePropertyShortTermRentalLease } from '../../../queries/PropertyFields/NonRentalFlagFields';
import { ToggleButtonLabelSize, YesNoToggleButton } from '@apply/components';
import { ButtonGroupTypes } from 'devextreme-react/button-group';
import { ApplicationQuestionReviewItem } from '../../components/ApplicationQuestionReviewItem';

interface ShortTermRentalLeaseProps {
    propertyGuid: string;
    required?: boolean;
    isReview?: boolean;
}

export const ShortTermRentalLease: React.FC<ShortTermRentalLeaseProps> = ({
    propertyGuid,
    required = false,
    isReview = false,
}) => {
    const label = 'After property is complete, will it be leased with any short term rentals (leases under 6 months)?';
    const [shortTermRentalLease, set_shortTermRentalLease] = usePropertyShortTermRentalLease(propertyGuid);

    const toggleButtonYesNoClick = (e: ButtonGroupTypes.ItemClickEvent) => {
        switch (e.itemData?.id.toLowerCase()) {
            case 'yes':
                set_shortTermRentalLease(true);
                return;
            case 'no':
                set_shortTermRentalLease(false);
                return;
            default:
                return;
        }
    };

    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={shortTermRentalLease ? 'Yes' : 'No'}
                />
            ) : (
                <YesNoToggleButton
                    id='toggleButtonRentalLease'
                    value={shortTermRentalLease}
                    onItemClick={toggleButtonYesNoClick}
                    width='230px'
                    height='40px'
                    required={required}
                    requiredMessage='Rental Lease information required'
                    label={label}
                    labelSize={ToggleButtonLabelSize.Medium}
                />
            )}
        </>
    );
};
